import {CopilotDropzone} from './copilot.enums';
import {CopilotSettings, CopilotContainerSettings} from './copilot.types';

const copilotContainerSettingsDefaults: CopilotContainerSettings = {
  x: 0,
  y: 0,
  width: 375,
  height: 450,
  dropzone: CopilotDropzone.None,
  activeDropzone: CopilotDropzone.None,
};

const copilotSettingsDefaults: CopilotSettings = {
  fontSize: 14,
  playbackRate: 1,
  isVoiceEnabled: false,
  isEditArticlesEnabled: false,
  promptToImageModel: 9, // open AI gpt-image-1
  promptToImageWithReferenceImagesModel: 11, // open AI gpt-image-1
  hiddenChatItemTypes: [],
};

const copilotPlaybackRates = [0.75, 1, 1.25, 1.5, 2];
const copilotFontSizes = [10, 12, 14, 16, 18];

export {
  copilotContainerSettingsDefaults,
  copilotSettingsDefaults,
  copilotPlaybackRates,
  copilotFontSizes,
};
